<template>
  <v-card class="store_tile pa-3 rounded-lg d-flex">
    <router-link :to="{ name: 'ecItemContent', query: { ecitem_id: ec_item_id, title: ec_item_name } }"
      class="text-decoration-none">
      <div class="store_tile__tumbnail col-auto" :style="thumbnail"></div>
    </router-link>
    <v-row class="d-flex pa-3 ml-1">
      <v-col cols="12" class="pa-0 mb-auto">
        <router-link :to="{ name: 'ecItemContent', query: { ecitem_id: ec_item_id, title: ec_item_name } }"
          class="text-decoration-none">
          <div class="store_tile__item_name ellipsis2" :style="itemNameStyle">
            {{ ec_item_name }}
          </div>
          <div class="store_tile__description ellipsis1" :style="descriptionStyle">{{ partnerName }}</div>
          <div class="store_tile__description ellipsis2 mb-2" :style="descriptionStyle">{{ decodeText(description) }}
          </div>
        </router-link>
      </v-col>
      <v-col cols="12" class="pa-0 mt-auto d-flex justify-end">
        <div class="mr-3" :style="priceStyle">
          <span class="font-weight-bold">{{ fomatPrice(price) }} 円</span>
        </div>
        <v-btn :loading="isLoading" id="id-watch-icon" :class="{ 'checked': isWatched }" size="small"
          background-color="white" :ripple="false" variant="text" icon="mdi-heart" density="compact"
          :style="{ 'alignSelf': 'center' }" @click="onClickedWatch">
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import helper from '../assets/js/helper.js'
import axios from 'axios'
const watchListApi = '/api/watch/item/save'

export default {
  name: 'StoreMainTile',
  props: {
    ec_item_id: {
      type: Number,
      required: true
    },
    ec_item_name: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      required: true
    },
    thumbnail: {
      type: Array,
      required: true
    },
    'isWatch': {
      type: Boolean
    },
    'supporter': {
      type: Number
    },
    'partnerName': {
      type: String,
      default: ''
    }
  },
  components: {
  },
  computed: {
  },
  mounted() {
    this.displayLoading = 'none';
    this.itemNameStyle.backgroundColor = 'transparent';
    this.itemNameStyle.height = 'auto';
    this.descriptionStyle.backgroundColor = 'transparent';
    this.descriptionStyle.height = 'auto';
    this.priceStyle.display = 'block';
    this.isWatched = this.isWatch;
  },
  watch: {
    isWatch(value) {
      this.isWatched = value;
    }
  },
  methods: {
    fomatPrice(price) {
      return helper.addComma(price)
    },
    decodeText(text) {
      return helper.decodeHtmlEscape(text);
    },
    onClickedWatch() {
      (async () => {
        try {
          this.isLoading = true
          var params = new URLSearchParams();
          params.append('ec_item_id', this.ec_item_id);
          params.append('mode', this.isWatched ? 'del' : 'add');
          const response = await axios.post(watchListApi, params)
          console.log(response)
          this.isWatched = !this.isWatched

        } catch (error) {
          console.log(error)
          alert('ウォッチリストの登録に失敗しました。画面右上のリロードボタンからページを更新後、再度お試しください。')
        } finally {
          setTimeout(() => {            
            this.isLoading = false
         }, 500);
        }
      })()
    }
  },
  data() {
    return {
      itemNameStyle: {
        backgroundColor: '#cacaca',
        height: '35px',
        width: '100%',
      },
      descriptionStyle: {
        backgroundColor: '#cacaca',
        height: '20px',
        width: '100%',
      },
      priceStyle: {
        display: 'none',
        textAlign: 'right',
      },
      displayLoading: 'block',
      isWatched: false,
      isLoading: false,
    }
  }
}
</script>

<style scoped>
.store_tile {
  position: relative;
  background-color: #fff;
}

.store_tile::after {
  content: "";
  position: absolute;
  width: 300%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.6;
  background: linear-gradient(110deg, rgba(250, 250, 250, 0) 0%, rgba(250, 250, 250, 0) 40%, rgba(250, 250, 250, 0.5) 50%, rgba(250, 250, 250, 0) 60%, rgba(250, 250, 250, 0) 100%);
  animation: gradient-animation_2 1.2s linear infinite;
  display: v-bind(displayLoading);
}

@keyframes gradient-animation_2 {
  0% {
    transform: translateX(-100%);
  }
}

.store_tile__tumbnail {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #cacaca;
}

.store_tile__item_name {
  font-size: 0.9rem;
  font-weight: bold;
}

.store_tile__description {
  margin-top: 4px;
  font-size: 0.75rem;
}

.store_tile__price {
  font-size: 0.8rem;
}

.store_pickup__thumbnail {
  aspect-ratio: 1/1;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #cacaca;
}

#id-watch-icon {
  color: #cccccc;
}

#id-watch-icon.checked {
  color: #ff0000;
}
</style>
